import React from "react";
import './Instruction.css';
import rChartMainImage from '../../images/r-chart-main.png';
import rChartBelow1 from '../../images/r-chart-below1.png';
import rChartAbove13 from '../../images/r-chart-above13.png';
// import chartsGridImage from '../../images/charts-grid.png';
import step1 from '../../images/step1.png';
import step2 from '../../images/step2.png';
import step3 from '../../images/step3.png';
import step4 from '../../images/step4.png';
// import formImage from '../../images/form.png';
// import formLimitImage from '../../images/form-limit.png';
// import scaleAdjustmentImage from '../../images/scale-adjustment.png';


function Instruction (){
  return(
    <div className="instruction" >
      <h2 className="instruction__title">ИНСТРУКЦИЯ</h2>
      <p className="instruction__text">
        Карта операционной эффективности позволяет сравнивать компании разного масштаба по эффективности (рентабельности затрат). Приложение загружает данные из базы данных ФНС.
      </p>
      <p className="instruction__text">
        Текущая версия приложения не ответит на все вопросы, возникающие в ходе анализа. Однако использование предложенного инструментария может помочь сформулировать правильные вопросы и гипотезы.
      </p>
      <div className="instruction__imgTextContainer">
        <img className="instruction__image" src={rChartMainImage} alt="" />
        <div className="instruction__rightText">
          <p className="instruction__text">
            <span className="span_bold">Вертикальная ось</span> - производительность труда в тыс. руб. в пересчёте на 1 человека.
          </p>
          <p className="instruction__text">
            <span className="span_underlined">Производительность труда</span> расчитывается как отношение <span className="span_underlined">выручки</span><span> </span>
            к <span className="span_underlined">среднесписочной численности</span> сотрудников.
          </p>
          <p className="instruction__text">
            <span className="span_bold">Горизонтальная ось</span> - удельные затраты в тыс. руб. в пересчёте на 1 человека.
          </p>
          <p className="instruction__text">
            <span className="span_underlined">Удельные затраты</span> - совокупность затрат от операционной деятельности (
            <span className="span_underlined">себестоимость продаж</span>, <span className="span_underlined">коммерческие</span> и<span> </span>
            <span className="span_underlined">управленческие</span> расходы), делённая на <span className="span_underlined">среднесписочную численность</span> сотрудников.
          </p>
        </div>
      </div>
      <div className="instruction__imgTextContainer">
        <img className="instruction__image" src={rChartBelow1} alt="" />
        <div className="instruction__rightText">
          <p className="instruction__text">
          <span className="span_red"><span className="span_dashed">Красная пунктирная линия</span></span> показывает уровень рентабельности R=1, при котором выручка равна затратам, и компания ничего не зарабатывает.
          </p>
          <p className="instruction__text">
            Если точка находится <span className="span_bold">ниже красной линии</span>, это говорит о том, что <span className="span_bold">компания терпит убытки</span>. Если у компании есть резервы, она может находиться в таком состоянии некоторое время.
          </p>
          <p className="instruction__text">
          <span className="span_underlined">Разовый выход</span> ниже красной линии может быть следствием <span className="span_underlined">кризиса</span> и <span className="span_underlined">влияния сильных внезапных факторов</span>.
          Если наблюдается <span className="span_underlined">динамика по снижению рентабельности</span> и постоянное пребывание на уровне рентабельности R&lt;1, это может говорить о <span className="span_underlined">системных проблемах</span> в компании и её системе менеджмента.
          </p>
        </div>
      </div>
      <div className="instruction__imgTextContainer">
        <img className="instruction__image" src={rChartAbove13} alt="" />
        <div className="instruction__rightText">
          <p className="instruction__text">
            <span className="span_green"><span className="span_dashed">Зелёная пунктирная линия</span></span> показывает уровень рентабельности R=1.3. Компаниям следует стремиться к зелёной линии, желательно с увеличением производительности труда.
          </p>
          <p className="instruction__text">
            Пересекать линию нужно с <span className="span_underlined">осторожностью</span>, т.к. это может быть сигналом, что компания в краткосрочной перспективе получает сверх результаты, и <span className="span_underlined">недостаточно вкладывает в будушее развитие</span>. Продолжительное нахождение выше зелёной линии может обернуться для компании <span className="span_underlined">серьёзным кризисом</span>, связанным с <span className="span_underlined">потерей контекста рынка, неспособностью своевременно адаптироваться к новым условиям и серьёзным отставанием от конкурентов</span>.
          </p>
        </div>
      </div>
      <h3 className="instruction__subTitle">КАК ПОЛЬЗОВАТЬСЯ</h3>
      <ul className="instruction__cardContainer">
        <li className="instruction__card">
          <img src={step1} alt="" className="instruction__cardImage" />
          <p className="instruction__text centeredText">Шаг 1</p>
          <p className="instruction__text centeredText">Нажмите на кнопку <span className="span_bold">Добавить</span></p>
        </li>
        <li className="instruction__card">
          <img src={step2} alt="" className="instruction__cardImage" />
          <p className="instruction__text centeredText">Шаг 2</p>
          <p className="instruction__text centeredText">Начните вводить <span className="span_bold">название</span> интересующей Вас компании</p>
        </li>
        <li className="instruction__card">
          <img src={step3} alt="" className="instruction__cardImage" />
          <p className="instruction__text centeredText">Шаг 3</p>
          <p className="instruction__text centeredText">Выберите нужную компанию из <span className="span_bold">выпадающего списка подсказок</span></p>
        </li>
        <li className="instruction__card">
          <img src={step4} alt="" className="instruction__cardImage" />
          <p className="instruction__text centeredText">Шаг 4</p>
          <p className="instruction__text centeredText">Нажмите клавишу <span className="span_bold">Enter</span> или на кнопку <span className="span_bold">Показать</span></p>
        </li>
      </ul>
    </div>
  )
}

export default Instruction;
